module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/Generic-9ed0e9a15001cc2af6d0905acbfd33af.png";